import React from 'react';
import { View, Text } from 'react-native';
import DefaultScreen from '@components/Global/DefaultScreenView';


const IndividualPublicDataScreen = () => {



  return (
    <DefaultScreen searchBar={{ showSearch: false }} backButton>
      <View>
        <Text>Hello World</Text>
      </View>
    </DefaultScreen>
  )
}
export default IndividualPublicDataScreen;
